module.exports = __webpack_public_path__ + "asset/image-app-store-download-5ce9749a693f6434.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/app-store-download.png
// module id = Es1N
// module chunks = 1